'use client';

import { createBrowserClient } from '@supabase/ssr';
import { getEnv } from '@/lib/env';
import { supabaseAuthCookieName } from './auth-cookie';

export function createSupabaseBrowserClient() {
  const env = getEnv();
  return createBrowserClient(env.NEXT_PUBLIC_SUPABASE_URL, env.NEXT_PUBLIC_SUPABASE_ANON_KEY, {
    // Nom de cookie figé : le serveur cible kong et en déduirait un autre nom.
    cookieOptions: { name: supabaseAuthCookieName() },
  });
}
